import React, { useState, useCallback } from 'react';
import { logout } from '../../util/LogoutUtil';
import '../../css/views/navMenu.css';
import classNames from 'classnames';
import { Badge } from "../../components/routing/Badge";
import { NavMenuLink } from "../../components/routing/NavMenuLink";
import { Typography } from '@mui/material';
import { withStyles, WithStyles } from '@mui/styles';
import NavMenuSubmenuListItem, { NavMenuItemType } from "./NavMenuSubmenuListItem";

const styles = (theme: any) => ({
  navMenuItem: {
    fontFamily: 'Satoshi-Variable',
    fontWeight: 700,
    fontSize: '1.14em',
    lineHeight: '150%',
    '&:hover': {
      fontWeight: 900,
    },
  },
  loginBtn: {
    fontFamily: 'Satoshi-Variable',
    fontWeight: 700,
    padding: '0.71em 1.78em',
    border: `3px solid ${theme.palette.secondary.main}`,
    color: theme.palette.secondary.main,
    cursor: 'pointer',
  },
  fontColor: {
    color: '#ffffff',
  },
  otherPageFontColor: {
    color: theme.palette.secondary.main,
  },
  hover: {
    '&:hover': {
      fontWeight: 700
    }
  }
});

interface NavMenuProps extends WithStyles<typeof styles> {
  navMenu?: NavMenuItemType[];
  closeNavMenu: () => void;
  overrideFontColor?: boolean;
  isSticky?: boolean;
  buyerSpaceUsageRedesign?: boolean;
}

const NavMenu: React.FC<NavMenuProps> = ({
  classes,
  navMenu,
  closeNavMenu,
  overrideFontColor = false,
  isSticky,
  buyerSpaceUsageRedesign,
}) => {
  const [activeMenuItem, setActiveMenuItemState] = useState('');
  const [activeSubmenu, setActiveSubmenu] = useState('');

  const handleLogout = useCallback((event: React.MouseEvent<Element>) => {
    event.stopPropagation();
    event.preventDefault();
    closeNavMenu();
    logout();
  }, [closeNavMenu]);

  const setActiveMenuItem = useCallback((menuItem: NavMenuItemType, subMenuItemPath?: string) => {
    closeNavMenu();
    setActiveMenuItemState(menuItem.path);
    setActiveSubmenu(subMenuItemPath ?? '');

    if (menuItem.label === 'How It Works') {
      const element = document.getElementById('how-it-works');
      element?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [closeNavMenu]);

  return (
    <div id="ssNavMenuContainer" onScroll={(e) => e.stopPropagation()}>
      <ul id="ssNavMenu">
        {navMenu?.map((menuItem, index) => {
          if (menuItem?.submenus) {
            return (
              <NavMenuSubmenuListItem
                key={index}
                activeMenuItem={activeMenuItem}
                activeSubmenu={activeSubmenu}
                buyerSpaceUsageRedesign={buyerSpaceUsageRedesign ?? false}
                classes={classes}
                index={index}
                isSticky={isSticky}
                logout={handleLogout}
                menuItem={menuItem}
                overrideFontColor={overrideFontColor}
                setActiveMenuItem={setActiveMenuItem}
                navMenu={[]}
              />
            );
          }

          return (
            <li key={index} className="ss-nav-menu ss-nav-menu-item">
              {menuItem?.modal ? (
                <Typography
                  variant="subtitle1"
                  component="span"
                  className={classNames(
                    menuItem?.highlighted ? "pointer ss-nav-menu-item-highlighted" : "pointer",
                    classes.navMenuItem
                  )}
                  onClick={() => setActiveMenuItem(menuItem)}
                >
                  {menuItem?.label}
                </Typography>
              ) : (
                <NavMenuLink
                  className={({isActive}) => isActive ? classNames(menuItem?.className, "active") : classNames(menuItem?.className)}
                  menuItem={menuItem}
                  onClick={() => setActiveMenuItem(menuItem)}
                >
                  {menuItem?.label !== "Log In" && (
                    <Typography
                      variant="subtitle1"
                      component="span"
                      className={classNames(
                        { "ss-nav-menu-item-highlighted": menuItem?.highlighted },
                        menuItem?.className,
                        classes.navMenuItem,
                        overrideFontColor && !isSticky && classes.fontColor
                      )}
                    >
                      {menuItem?.label}
                    </Typography>
                  )}

                  <Badge
                    type="left"
                    menuItem={menuItem}
                  />

                  {menuItem?.label === "Log In" && ['/', '/about'].includes(window.location.pathname) ? (
                    <Typography
                      variant="subtitle1"
                      component="span"
                      className={isSticky ? classes.loginBtn : 'login_btn'}
                    >
                      {menuItem?.label}
                    </Typography>
                  ) : menuItem?.label === "Log In" && window.location.pathname !== '/' && (
                    <Typography
                      variant="subtitle1"
                      component="span"
                      className={classes.loginBtn}
                    >
                      {menuItem?.label}
                    </Typography>
                  )}
                </NavMenuLink>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default withStyles(styles)(NavMenu);